import axios from 'axios'

const origin = process.env.VUE_APP_API_ORIGIN
const responseData = response => response.data

export default {
  list (enabledOnly = true) {
    return axios
      .get(`${origin}/project-notifications/company/projects`, {
        params: { enabledOnly: Boolean(enabledOnly) }
      })
      .then(responseData)
  },
  getSettings () {
    return axios
      .get(`${origin}/project-notifications/company/settings`)
      .then(responseData)
  },
  updateSettings (payload) {
    return axios
      .post(`${origin}/project-notifications/company/settings`, payload)
      .then(responseData)
  },
  test (scheduleCode, projectId, payload) {
    return axios
      .post(
        `${origin}/project-notifications/company/settings/${scheduleCode}/test/${projectId}`,
        payload
      )
      .then(responseData)
  }
}
